import { client } from "api";
import { Company } from "models/Company";
import { CompanyContact } from "models/CompanyContact";

export type GetContactsRequest = { companyId: Company["id"] };

export type GetContactsResponse = CompanyContact[];

export const getContacts = ({ companyId }: GetContactsRequest) =>
  client.get<GetContactsResponse>(`/company/${companyId}/contacts`).then((res) => res.data);
